import React, { Component } from 'react';
import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'

import './Teach.less';
import audio3 from '../../static/audio/fanshu.mp3';

export default class Teach extends Component {
    constructor(props){
        super(props);
        this.state = {
            action: false
        };
        this.timeOutArr = [];
    }
    componentDidMount(){
        this.timeOutArr.push(
            setTimeout(() => {
                this.duration1 = this.audio1.duration;
                this.duration2 = this.audio2.duration;
                console.log(this.duration1, this.duration2);
            }, 200)
        );
        this.timeOutArr.push(
            setTimeout(() => {
                try {
                    const duration1 = Number(this.duration1)>0?this.duration1:3;
                    this.audio1.play();
                    this.timeOutArr.push(
                        setTimeout(() => {
                            const { action } = this.state;
                            this.audio3.play();
                            this.setState({action: !action});
                            this.timeOutArr.push(
                                setTimeout(() => {
                                    const duration2 = Number(this.duration2)>0?this.duration2:3;
                                    this.audio2.play();
                                    this.timeOutArr.push(
                                        setTimeout(() => {
                                            this.props.teachComplete();
                                        }, Math.round(duration2 * 1000) + 1000)
                                    )
                                }, 1500)
                            )
                        }, Math.round(duration1 * 1000) + 1000)
                    )
                } catch (error) {
                    clientApi.closeH5Page({reason:'homeworkError'}); 
                }
            }, 1500)
        );
        this.audio1.onended = () => {
            
        }
        this.audio2.onended = () => {
            this.timeOutArr.push(
                setTimeout(() => {
                    
                }, 1000)
            )
        }
    }

    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }

    render(){
        const { action } = this.state;
        const { questionInfo } = this.props;
        return(
            <div className="teach" >
                <div className="teach_pic_wrap" onClick={this.handleClick}>
                    <div className={`teach_pic pic1 action right ${action?'active':''}`} style={{backgroundImage:`url(${questionInfo.pictureAOne})`}}></div>
                    <div className="teach_pic pic1 left" style={{backgroundImage:`url(${questionInfo.pictureAOne})`}}></div>
                    <div className="teach_pic pic2 right" style={{backgroundImage:`url(${questionInfo.pictureBOne})`}}></div>
                    <div className={`teach_pic pic2 action left ${action?'active':''}`} style={{backgroundImage:`url(${questionInfo.pictureBOne})`}}></div>
                </div>
                <audio src={questionInfo.audioA} ref={com => this.audio1 = com} preload="true"></audio>
                <audio src={questionInfo.audioB} ref={com => this.audio2 = com} preload="true"></audio>
                <audio src={audio3} ref={com => this.audio3 = com} preload="true"></audio>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Teach.jsx